const utils = {
  parseHTMLTableFromFundOverviewSection: () => {
    const tableSection = document.getElementById('fund-overview');
    if (!!tableSection && tableSection.getElementsByTagName('table').length > 0) {
      const tableEl = tableSection.getElementsByTagName('table')[0];
      const rows = tableEl.querySelectorAll('tbody > tr');
      const elements = Array.from(rows).map(row => {
        const cells = Array.from(row.querySelectorAll('td'));
        return {
          [cells[0].textContent.trim()]: cells[1].textContent.trim(),
        };
      });
      return elements.find(x => x.ISIN);
    }
    return null;
  },

  parseHTMLTableFromListingSection: () => {
    const tableSection = document.getElementById('fund-listing-codes');
    if (!!tableSection && tableSection.getElementsByTagName('table').length > 0) {
      const tableEl = tableSection.getElementsByTagName('table')[0];
      const columns = Array.from(tableEl.querySelectorAll('th')).map(it => it.textContent);
      const rows = tableEl.querySelectorAll('tbody > tr');
      const elements = Array.from(rows).map(row => {
        const cells = Array.from(row.querySelectorAll('td'));
        return columns.reduce((obj, col, idx) => {
          // eslint-disable-next-line no-param-reassign
          obj[col] = cells[idx].textContent;
          return obj;
        }, {});
      });
      return elements.find(x => x.ISIN);
    }
    return null;
  },
};

export default utils;
